// extracted by mini-css-extract-plugin
module.exports = {"current-user":"current-user--27uKH"};